/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { SkeletonRow } from 'src/components/ts-components/SkeletonBlock'
import { PLUGIN_PREVIEW_HEIGHT, WEBSITE_PLUGIN_CARDS } from '../constants'
import { ApiAccessCard } from './ApiAccessCard'
import { ApiAccessSkeleton } from './ApiAccessSkeleton'
import { PluginBuilderLayout } from './PluginBuilderLayout'

/** One bar per settings group (Embed, Tabs, Theme, Display). */
const SETTINGS_GROUPS = 4
const GROUP_HEADER_HEIGHT = 72
const FIELD_HEIGHT = 40

/** The settings card with a bar per collapsed group. */
const SettingsSkeleton = () => (
  <ApiAccessCard
    title={capitalizeWords(WEBSITE_PLUGIN_CARDS.settings.title)}
    subtitle={WEBSITE_PLUGIN_CARDS.settings.subtitle}
  >
    <div css={stackStyle}>
      {Array.from({ length: SETTINGS_GROUPS }, (_, group) => (
        <SkeletonRow key={group} height={GROUP_HEADER_HEIGHT} />
      ))}
    </div>
  </ApiAccessCard>
)

/** The preview card (URL field + frame) and the embed code card. */
const ContentSkeleton = () => (
  <>
    <ApiAccessCard
      title={capitalizeWords(WEBSITE_PLUGIN_CARDS.preview.title)}
      subtitle={WEBSITE_PLUGIN_CARDS.preview.subtitle}
    >
      <SkeletonRow height={FIELD_HEIGHT} />
      <SkeletonRow height={PLUGIN_PREVIEW_HEIGHT} />
    </ApiAccessCard>
    <ApiAccessCard
      title={capitalizeWords(WEBSITE_PLUGIN_CARDS.embed.title)}
      subtitle={WEBSITE_PLUGIN_CARDS.embed.subtitle}
    >
      <ApiAccessSkeleton />
    </ApiAccessCard>
  </>
)

/** Stands in for the snippet builder while the account's organization loads. */
export const PluginBuilderSkeleton = () => (
  <div aria-hidden='true'>
    <PluginBuilderLayout
      settings={<SettingsSkeleton />}
      content={<ContentSkeleton />}
    />
  </div>
)

const stackStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
